import { RegionEnum, RegionTLDEnum } from "@edp-enums/region.enum";

export function getTLD(): string {
    const hostnameParts = window.location.hostname.split(".");
    const topLevelDomain = hostnameParts[hostnameParts.length - 1];

    return topLevelDomain;
}

export function getRegionByTLD(): RegionEnum {
    let region: RegionEnum;
    const topLevelDomain: string = getTLD();

    switch (topLevelDomain) {
        case RegionTLDEnum.TLD_PT:
            region = RegionEnum.PT;
            break;
        case RegionTLDEnum.TLD_ES:
            region = RegionEnum.ES;
            break;
        default:
            region = RegionEnum.PT;
            break;
    }
    return region;
}
